/**
 * 処分場処理方法に紐付く処分前廃棄物種類ID
 */
import Vue from 'vue'
import {DRIVER_ENDPOINT} from "@/constants/httpConst";

const search_recycle_disposer_disposal_method_item = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {

    /**
     * 処分場処理方法に紐付く処分前廃棄物種類IDの取得
     * @param param0
     * @param param0.commit
     * @param recycle_disposer_disposal_method_id { Number } 処分場処理方法ID
     * @return {Promise<unknown>}
     */
    show ({ commit }, recycle_disposer_disposal_method_id) {
      const path = `${DRIVER_ENDPOINT}/masters/search/recycle_disposer_disposal_methods/${recycle_disposer_disposal_method_id}/items`
      return new Promise((resolve) => {
        Vue.$http.get(path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default search_recycle_disposer_disposal_method_item
